import { css } from 'aphrodite';
import * as React from 'react';
import { TargetGoalsIcon } from '../../../../web/components/svgs/icons/TargetGoalsIcon';
import {
	AppDrawerContent,
	AppDrawerToolbarButton,
	CoffeeDrawerProvider,
	CoffeeDrawerToolbar,
	SideDrawer,
} from '../../../../web/components-v2/Drawer/AppDrawer';
import { TabContent, TabList, TabRoot, TabTrigger } from '../../../../web/components-v2/Tabs';
import { RepCoachingGoalsContent } from '../../../components/RepCoachingGoalsContent';
import { BasicPage } from '../../BasicPage';
import { LiveCallsTab } from './components/LiveCallsTab';
import { PracticeCallsTab } from './components/PracticeCallsTab';
import { styleSheet } from './styles';

export const COFFEE_DRAWER_VALUE_CALL_ANALYSIS_SDR_GOALS = 'coffee-call-analysis-sdr-goals';

export const CallAnalysis: React.FC = () => {
	const [selectedTab, setSelectedTab] = React.useState<string>('live');
	const [selectedDrawerValue, setSelectedDrawerValue] = React.useState<string | null>(null);
	const [sdrGoalsState, setSdrGoalsState] = React.useState<{ userId: string; userName: string } | null>(null);

	const drawerValue = sdrGoalsState ? selectedDrawerValue : null;

	const handleOpenSdrGoals = React.useCallback((userId: string, userName: string) => {
		setSdrGoalsState({ userId, userName });
		setSelectedDrawerValue(COFFEE_DRAWER_VALUE_CALL_ANALYSIS_SDR_GOALS);
	}, []);

	const handleCloseSdrGoals = React.useCallback(() => {
		setSdrGoalsState(null);
		setSelectedDrawerValue(null);
	}, []);

	return (
		<CoffeeDrawerProvider value={drawerValue} onValueChange={setSelectedDrawerValue}>
			<div className={css(styleSheet.root)}>
				<div className={css(styleSheet.callAnalysisRoot)}>
					<BasicPage appearance='light' title='Call Analysis'>
						<TabRoot value={selectedTab} onValueChange={setSelectedTab}>
							<TabList>
								<TabTrigger value='live'>Live Calls</TabTrigger>
								<TabTrigger value='practice'>Practice Calls</TabTrigger>
							</TabList>
							<TabContent value='live' className={css(styleSheet.tabContent)}>
								<LiveCallsTab onSDRClick={handleOpenSdrGoals} />
							</TabContent>
							<TabContent value='practice' className={css(styleSheet.tabContent)}>
								<PracticeCallsTab />
							</TabContent>
						</TabRoot>
					</BasicPage>
				</div>
				<SideDrawer styles={[styleSheet.drawer]}>
					<AppDrawerContent value={COFFEE_DRAWER_VALUE_CALL_ANALYSIS_SDR_GOALS} styles={[styleSheet.drawerContent]}>
						{sdrGoalsState ? (
							<RepCoachingGoalsContent
								userId={sdrGoalsState.userId}
								userName={sdrGoalsState.userName}
								onClose={handleCloseSdrGoals}
							/>
						) : null}
					</AppDrawerContent>
					<CoffeeDrawerToolbar>
						<AppDrawerToolbarButton
							value={COFFEE_DRAWER_VALUE_CALL_ANALYSIS_SDR_GOALS}
							tooltip='SDR coaching goals'
							disabled={!sdrGoalsState}
						>
							<TargetGoalsIcon />
						</AppDrawerToolbarButton>
					</CoffeeDrawerToolbar>
				</SideDrawer>
			</div>
		</CoffeeDrawerProvider>
	);
};
